import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';

import { InvoicingRoutingModule } from './invoicing-routing.module';
import { InvoicingListComponent } from './invoicing-list/invoicing-list.component';
import { InvoicingNewComponent } from './invoicing-new/invoicing-new.component';
import { InvoicingWarehouseComponent } from './invoicing-warehouse/invoicing-warehouse.component';
import { InvoicingWarehouseNewComponent } from './invoicing-warehouse-new/invoicing-warehouse-new.component';
import { InvoicesPanelComponent } from './panels/invoices-panel/invoices-panel.component';
import { ReceivablePanelComponent } from './panels/receivable-panel/receivable-panel.component';

@NgModule({
    declarations: [
        InvoicingListComponent,
        InvoicingNewComponent,
        InvoicingWarehouseComponent,
        InvoicingWarehouseNewComponent,
        InvoicesPanelComponent,
        ReceivablePanelComponent
    ],
    imports: [
        CommonModule,
        InvoicingRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        AgGridModule,
        RouterModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InvoicingModule { }
